/*
Copyright (c) 2015-present NAVER Corp.
name: @egjs/react-flicking
license: MIT
author: NAVER Corp.
repository: https://github.com/naver/egjs-flicking/tree/master/packages/react-flicking
version: 4.3.0
*/
import * as React from 'react';
import React__default from 'react';
import ListDiffer from '@egjs/list-differ';
import VanillaFlicking__default, { ExternalPanel, ExternalRenderer, sync, getDefaultCameraTransform, getRenderingPanels, EVENTS, withFlickingMethods } from '@egjs/flicking';
export * from '@egjs/flicking';
import { isFragment } from 'react-is';
import { findDOMNode } from 'react-dom';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

/* global Reflect, Promise */
var extendStatics = function (d, b) {
  extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
  };

  return extendStatics(d, b);
};

function __extends(d, b) {
  if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
  extendStatics(d, b);

  function __() {
    this.constructor = d;
  }

  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function () {
  __assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};
function __decorate(decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
function __generator(thisArg, body) {
  var _ = {
    label: 0,
    sent: function () {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];

      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;

        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };

        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;

        case 7:
          op = _.ops.pop();

          _.trys.pop();

          continue;

        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }

          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }

          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }

          if (t && _.label < t[2]) {
            _.label = t[2];

            _.ops.push(op);

            break;
          }

          if (t[2]) _.ops.pop();

          _.trys.pop();

          continue;
      }

      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
}
function __spreadArray(to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
}

var DEFAULT_PROPS = {
  viewportTag: "div",
  cameraTag: "div",
  plugins: [],
  useFindDOMNode: false,
  hideBeforeInit: false,
  firstPanelSize: undefined,
  onReady: function (e) {},
  onBeforeResize: function (e) {},
  onAfterResize: function (e) {},
  onHoldStart: function (e) {},
  onHoldEnd: function (e) {},
  onMoveStart: function (e) {},
  onMove: function (e) {},
  onMoveEnd: function (e) {},
  onWillChange: function (e) {},
  onChanged: function (e) {},
  onWillRestore: function (e) {},
  onRestored: function (e) {},
  onSelect: function (e) {},
  onNeedPanel: function (e) {},
  onVisibleChange: function (e) {},
  onReachEdge: function (e) {},
  onPanelChange: function (e) {}
};

var ReactPanel = function (_super) {
  __extends(ReactPanel, _super);

  function ReactPanel() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  var __proto = ReactPanel.prototype;
  Object.defineProperty(__proto, "element", {
    get: function () {
      return this._externalComponent.element;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "rendered", {
    get: function () {
      return !this._externalComponent.hide;
    },
    enumerable: false,
    configurable: true
  });

  __proto.markForShow = function () {
    this._externalComponent.hide = false;
  };

  __proto.markForHide = function () {
    this._externalComponent.hide = true;
  };

  return ReactPanel;
}(ExternalPanel);

var ReactRenderer = function (_super) {
  __extends(ReactRenderer, _super);

  function ReactRenderer(options) {
    var _this = _super.call(this, options) || this;

    _this._reactFlicking = options.reactFlicking;
    return _this;
  } // eslint-disable-next-line @typescript-eslint/require-await


  var __proto = ReactRenderer.prototype;

  __proto.render = function () {
    return __awaiter(this, void 0, void 0, function () {
      var flicking, reactFlicking;
      return __generator(this, function (_a) {
        flicking = this._flicking;
        reactFlicking = this._reactFlicking;
        if (!flicking || !reactFlicking.mounted) return [2
        /*return*/
        ];

        this._updateRenderingPanels();

        return [2
        /*return*/
        , new Promise(function (resolve) {
          reactFlicking.setRenderCallback(resolve);
          reactFlicking.setState({});
        })];
      });
    });
  };

  __proto.forceRenderAllPanels = function () {
    return __awaiter(this, void 0, void 0, function () {
      var reactFlicking;
      return __generator(this, function (_a) {
        reactFlicking = this._reactFlicking;
        if (!reactFlicking.mounted) return [2
        /*return*/
        ];

        this._panels.forEach(function (panel) {
          return panel.markForShow();
        });

        return [2
        /*return*/
        , new Promise(function (resolve) {
          reactFlicking.setRenderCallback(resolve);
          reactFlicking.setState({});
        })];
      });
    });
  };

  __proto._collectPanels = function () {
    var _this = this;

    var align = this._getPanelAlign();

    var children = this._reactFlicking.reactPanels;
    this._panels = children.map(function (panelComponent, index) {
      return new ReactPanel({
        flicking: _this._flicking,
        index: index,
        align: align,
        externalComponent: panelComponent
      });
    });
  };

  __proto._createPanel = function (externalComponent, options) {
    return new ReactPanel(__assign({
      externalComponent: externalComponent
    }, options));
  };

  return ReactRenderer;
}(ExternalRenderer);

var NonStrictPanelComponent = function (_super) {
  __extends(NonStrictPanelComponent, _super);

  function NonStrictPanelComponent() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.hide = false;
    return _this;
  }

  var __proto = NonStrictPanelComponent.prototype;
  Object.defineProperty(__proto, "element", {
    get: function () {
      return findDOMNode(this);
    },
    enumerable: false,
    configurable: true
  });

  __proto.render = function () {
    return this.hide ? React.createElement(React.Fragment, null) : this.props.children;
  };

  return NonStrictPanelComponent;
}(React.Component);

var StrictPanelComponent = function (_super) {
  __extends(StrictPanelComponent, _super);

  function StrictPanelComponent() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.hide = false;
    _this._elRef = React.createRef();
    return _this;
  }

  var __proto = StrictPanelComponent.prototype;
  Object.defineProperty(__proto, "element", {
    get: function () {
      return this._elRef.current;
    },
    enumerable: false,
    configurable: true
  });

  __proto.render = function () {
    return this.hide ? React.createElement(React.Fragment, null) : this._getElement();
  };

  __proto._getElement = function () {
    return React.cloneElement(React.Children.only(this.props.children), {
      ref: this._elRef
    });
  };

  return StrictPanelComponent;
}(React.Component);

var ViewportSlot = function (_a) {
  var children = _a.children;
  return React__default.createElement(React__default.Fragment, null, children);
};

var Flicking = function (_super) {
  __extends(Flicking, _super);

  function Flicking(props) {
    var _this = _super.call(this, props) || this;

    _this._panels = [];
    _this._panels = _this._getChildren().map(function () {
      return React.createRef();
    });
    return _this;
  }

  var __proto = Flicking.prototype;
  Object.defineProperty(__proto, "mounted", {
    get: function () {
      return this._mounted;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(__proto, "reactPanels", {
    get: function () {
      return this._panels.map(function (panel) {
        return panel.current;
      });
    },
    enumerable: false,
    configurable: true
  });

  __proto.setRenderCallback = function (callback) {
    this._renderCallback = callback;
  };

  __proto.componentDidMount = function () {
    this._mounted = true;
    var props = this.props;
    var flicking = new VanillaFlicking__default(this._viewportElement, __assign(__assign({}, props), {
      renderExternal: {
        renderer: ReactRenderer,
        rendererOptions: {
          reactFlicking: this
        }
      }
    }));
    this._vanillaFlicking = flicking;

    this._bindEvents();

    var children = this._getChildren();

    this._jsxDiffer = new ListDiffer(children, function (panel) {
      return panel.key;
    });
    this._pluginsDiffer = new ListDiffer();

    this._checkPlugins();
  };

  __proto.componentWillUnmount = function () {
    this._mounted = false;

    this._vanillaFlicking.destroy();
  };

  __proto.shouldComponentUpdate = function (nextProps) {
    var children = this._getChildren(nextProps.children);

    var diffResult = this._jsxDiffer.update(children);

    this._panels = children.map(function () {
      return React.createRef();
    });
    this._diffResult = diffResult;
    return true;
  };

  __proto.componentDidUpdate = function () {
    var flicking = this._vanillaFlicking;
    var diffResult = this._diffResult;

    this._checkPlugins();

    this._renderCallback && this._renderCallback();
    if (!diffResult || !flicking.initialized) return;
    sync(flicking, diffResult, this.reactPanels);

    if (diffResult.added.length > 0 || diffResult.removed.length > 0) {
      this.setState({});
    }

    this._diffResult = null;
  };

  __proto.render = function () {
    var _this = this;

    var _a;

    var props = this.props;
    var Viewport = props.viewportTag;
    var Camera = props.cameraTag;
    var attributes = {};
    var flicking = this._vanillaFlicking;
    var initialized = this._diffResult && flicking && flicking.initialized;

    for (var name in props) {
      if (!(name in DEFAULT_PROPS) && !(name in VanillaFlicking__default.prototype)) {
        attributes[name] = props[name];
      }
    }

    var viewportClasses = ["flicking-viewport"];
    var isHorizontal = flicking ? flicking.horizontal : (_a = props.horizontal) !== null && _a !== void 0 ? _a : true;

    if (!isHorizontal) {
      viewportClasses.push("vertical");
    }

    if (props.hideBeforeInit && !initialized) {
      viewportClasses.push("flicking-hidden");
    }

    if (attributes.className) {
      viewportClasses.push(attributes.className);
    }

    var cameraProps = !initialized && props.firstPanelSize ? {
      style: {
        transform: getDefaultCameraTransform(this.props.align, this.props.horizontal, this.props.firstPanelSize)
      }
    } : {};
    var children = initialized ? getRenderingPanels(flicking, this._diffResult) : this._getChildren();
    var panels = this.props.useFindDOMNode ? children.map(function (child, idx) {
      return React.createElement(NonStrictPanelComponent, {
        key: child.key,
        ref: _this._panels[idx]
      }, child);
    }) : children.map(function (child, idx) {
      return React.createElement(StrictPanelComponent, {
        key: child.key,
        ref: _this._panels[idx]
      }, child);
    });
    return React.createElement(Viewport, __assign({}, attributes, {
      className: viewportClasses.join(" "),
      ref: function (e) {
        e && (_this._viewportElement = e);
      }
    }), React.createElement(Camera, __assign({
      className: "flicking-camera"
    }, cameraProps), panels), this._getViewportSlot());
  };

  __proto._bindEvents = function () {
    var _this = this;

    var flicking = this._vanillaFlicking;
    var props = this.props;
    Object.keys(EVENTS).forEach(function (eventKey) {
      var eventName = EVENTS[eventKey];
      var propName = "on" + (eventName.charAt(0).toUpperCase() + eventName.slice(1));
      flicking.on(eventName, function (e) {
        e.currentTarget = _this;
        props[propName](e);
      });
    });
    flicking.once(EVENTS.READY, function () {
      _this.forceUpdate();
    });
  };

  __proto._checkPlugins = function () {
    var _a, _b;

    var _c = this._pluginsDiffer.update(this.props.plugins),
        list = _c.list,
        added = _c.added,
        removed = _c.removed,
        prevList = _c.prevList;

    (_a = this._vanillaFlicking).addPlugins.apply(_a, added.map(function (index) {
      return list[index];
    }));

    (_b = this._vanillaFlicking).removePlugins.apply(_b, removed.map(function (index) {
      return prevList[index];
    }));
  };

  __proto._getChildren = function (children) {
    var _this = this;

    if (children === void 0) {
      children = this.props.children;
    }

    return React.Children.toArray(children).filter(function (child) {
      return child.type !== ViewportSlot;
    }).reduce(function (all, child) {
      return __spreadArray(__spreadArray([], all), _this._unpackFragment(child));
    }, []);
  };

  __proto._getViewportSlot = function () {
    return React.Children.toArray(this.props.children).filter(function (child) {
      return child.type === ViewportSlot;
    });
  };

  __proto._unpackFragment = function (child) {
    var _this = this;

    return isFragment(child) ? React.Children.toArray(child.props.children).reduce(function (allChilds, fragChild) {
      return __spreadArray(__spreadArray([], allChilds), _this._unpackFragment(fragChild));
    }, []) : [child];
  };

  Flicking.defaultProps = DEFAULT_PROPS;

  __decorate([withFlickingMethods], Flicking.prototype, "_vanillaFlicking", void 0);

  return Flicking;
}(React.Component);

/*
 * Copyright (c) 2015 NAVER Corp.
 * egjs projects are licensed under the MIT license
 */

export { ViewportSlot, Flicking as default };
//# sourceMappingURL=flicking.esm.js.map
